import React from "react";
import "./GameMode.css";

function GameMode({ onSelect }) {

    const modes = [
    {
        id: "2-player",
        title: "2 Players",
        description: "Play against 1 opponent • Only 1 winner",
        icon: "👥",
        className: "mode-green",

        activePlayers: [
            "blue",
            "green",
        ],

        humanPlayer: "blue",

        computerPlayers: [
            "green",
        ],

        offline: false,
    },

    {
        id: "3-player",
        title: "3 Players",
        description: "Play against 2 opponents • Only 1 winner",
        icon: "👥",
        className: "mode-yellow",

        activePlayers: [
            "blue",
            "green",
            "yellow",
        ],

        humanPlayer: "blue",

        computerPlayers: [
            "green",
            "yellow",
        ],

        offline: false,
    },

    {
        id: "4-player",
        title: "4 Players",
        description: "Play against 3 opponents • Only 1 winner",
        icon: "👥",
        className: "mode-blue",

        activePlayers: [
            "blue",
            "red",
            "green",
            "yellow",
        ],

        humanPlayer: "blue",

        computerPlayers: [
            "red",
            "green",
            "yellow",
        ],

        offline: false,
    },

    {
        id: "offline-4-player",
        title: "Offline 4 Players",
        description: "Play with 4 players",
        icon: "🎮",
        className: "mode-red",

        activePlayers: [
            "blue",
            "red",
            "green",
            "yellow",
        ],

        humanPlayers: [
            "blue",
            "red",
            "green",
            "yellow",
        ],

        computerPlayers: [],

        offline: true,
    },
];

    return (
        <div className="ludo-mode-screen">

            {/* Decorative tokens */}
            <div className="floating-token token-green"></div>
            <div className="floating-token token-yellow"></div>
            <div className="floating-token token-red"></div>
            <div className="floating-token token-blue"></div>

            <div className="ludo-mode-card">

                {/* Logo */}
                <div className="ludo-logo">

                    <div className="logo-dice">

                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>

                    </div>

                    <div>
                        <h1>LUDO</h1>
                        <p>CLASSIC</p>
                    </div>

                </div>


                <div className="mode-heading">

                    <h2>
                        Choose Your Game
                    </h2>

                    <p>
                        Select how you want to play
                    </p>

                </div>


                <div className="game-mode-list">

                    {modes.map((mode) => (

                        <button
                            key={mode.id}
                            type="button"
                            className={`premium-mode ${mode.className}`}
                            onClick={() => onSelect(mode)}
                        >

                            <div className="mode-icon">
                                {mode.icon}
                            </div>

                            <div className="mode-text">

                                <strong>
                                    {mode.title}
                                </strong>

                                <span>
                                    {mode.description}
                                </span>

                            </div>

                            <div className="mode-arrow">
                                →
                            </div>

                        </button>

                    ))}

                </div>


                <div className="ludo-footer">

                    <span className="mini-dot green"></span>
                    <span className="mini-dot yellow"></span>
                    <span className="mini-dot red"></span>
                    <span className="mini-dot blue"></span>

                    <span>
                        Classic Ludo
                    </span>

                </div>

            </div>

        </div>
    );
}

export default GameMode;